module.exports = __webpack_public_path__ + "img/mms-1.bfb8668d.jpg";